export default {
  'groupings.list.header.code': 'Código',
  'groupings.list.header.description': 'Descrição',
  'groupings.list.header.installments': 'Número de Parcelas',
  'groupings.list.header.amount': 'Valor Total',
  'groupings.list.header.actions': 'Ações',

  'groupings.generate.clusters': 'Gerar Agrupamento',
  'groupings.generate.searchAccounts': 'Buscar Contas',

  'groupings.form.company': 'Empresa',
  'groupings.form.debtor': 'Devedor',
  'groupings.form.customer': 'Cliente',
  'groupings.form.insurer': 'Seguradora',
};
